<template>
<div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
        <el-form-item label="保险公司名称" prop="insuranceName">
            <el-input
            v-model="queryParams.insuranceName"
            placeholder="请输入保险公司"
            clearable
            @keyup.enter.native="handleQuery"
            >
                
            </el-input>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
    </el-form>
    
    <el-row :gutter="10" class="mb8">
        <el-col>
            <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="handleAdd"
                v-hasPermi="['config:insurance:add']"
                >新增</el-button>
        </el-col>
       
        <right-toolbar :showSearch.sync="showSearch" @queryTable="getList">
        </right-toolbar>

    </el-row>

    <!-- 表格 -->
    <el-table
        v-loading="loading"
        :data="insuranceListData"
        row-key="id">
        <el-table-column label="序号" type="index">
        </el-table-column>

        <el-table-column label="保险公司key" prop="insureCompanyKey">    
        </el-table-column>

        <el-table-column label="保险公司名称"  prop="insureCompanyName">
        </el-table-column>

        <el-table-column label="操作">
            <template slot-scope="scope">
                

                <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                v-hasPermi="['config:insurance:edit']">
                    修改
                </el-button>
                <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                v-hasPermi="['config:insurance:remove']">
                    删除
                </el-button>
            </template>
        </el-table-column>
        
        
    </el-table>

    <!-- 对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="保险公司代号" prop="insureCompanyKey">
                        <el-input v-model="form.insureCompanyKey"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="保险公司名称" prop="insureCompanyName">
                        <el-input v-model="form.insureCompanyName"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>

            

            <el-row>
                <el-col :span="12" >
                    <el-form-item label="公钥(AccessKey)" prop="accessKey"> 
                        <el-input v-model="form.accessKey">

                        </el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="12" >
                    <el-form-item label="秘钥(SecretKey)" prop="secretKey">
                        <el-input v-model="form.secretKey">

                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>

                <el-col :span="12">
                    <el-form-item label="通讯类型">
                       
                        <el-select v-model="form.communicationType" placeholder="请选择">
                            <el-option
                            v-for="item in communicationOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                </el-col>
                <el-col :span="12">
                    <el-form-item label="域名" prop="domain">
                        <el-input v-model="form.domain"> 
                        </el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="排序">
                        <el-input-number v-model="form.orderNum"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="备注">
                        <el-input v-model="form.remark" type="textarea">

                        </el-input>
                    </el-form-item>
                </el-col>
           
            </el-row>
            
        </el-form>
        
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>

import {listInsurance,addInsurance,updateInsurance,delInsurance} from '@/api/vehicleConfig/insurance';

export default{
    name:'ConfigInsurance',
    data(){
        return{
            // 遮罩层
            loading: false,
            // 显示搜索条件
            showSearch: true,
            // 表格树数据
            insuranceListData:[],
            // 查询参数
            queryParams:{
                insuranceName:''
            },

            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 表单参数
            form: {},
            rules:{
                insureCompanyKey:[
                    { required: true, message: "保险公司标志不能为空", trigger: "blur" }
                ],
                insureCompanyName: [
                    { required: true, message: "保险公司名称不能为空", trigger: "blur" }
                ],
            },
            communicationOptions:[
                {label:'博车接口通讯',value:'boche-api'},{label:'爬虫采集',value:'capture'}
            ],

        }
    },
    created(){
        this.getList();
    },
    methods:{
        getList() {
            this.loading=true;
            listInsurance(this.queryParams)
            .then(response=>{
                this.insuranceListData=response.data;
                this.loading = false;
            })
        },
        //查询
        handleQuery(){
            this.getList();
        },
        //重置
        resetQuery(){
            
            this.$refs["queryForm"].resetFields();
            this.handleQuery();
        },

        //增加reset
        handleAdd(){ 
            this.open=true;
            this.title = "增加保险公司";   
        },

        //修改
        handleUpdate(row){
            this.open = true;
            this.title = "修改部门";
            this.form=row;
           
        },

        //删除
        /** 删除按钮操作 */
        handleDelete(row) {

            this.$modal.confirm('是否确认删除名称为"' + row.insureCompanyName + '"的数据项？')
            .then(function() {
                return delInsurance({'id':row.id});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {});
        },

        reset(){
            // this.resetForm("form");
            this.$nextTick(()=>{
                this.$refs["form"].resetFields();
            });
            
            this.form.orderNum=0;

        },
        //提交
        submitForm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                 
                    if (this.form.id != undefined) {
                     
                        updateInsurance(this.form).then(response => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addInsurance(this.form).then(response => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                }
                }
            });
        },

        cancel(){
            this.open = false;
            
        }
        
       

    }
}
</script>